import { Bot, Sparkles } from "lucide-react";

const MODELS = [
  { key: "claude", label: "Claude", Icon: Sparkles },
  { key: "chatgpt", label: "ChatGPT", Icon: Bot },
];

export const AIModelSelector = ({ value, onChange, size = "sm", testIdPrefix = "ai-model" }) => (
  <div className="inline-flex rounded-full border bg-background p-0.5" role="radiogroup" aria-label="Modelo IA" data-testid={`${testIdPrefix}-selector`}>
    {MODELS.map(({ key, label, Icon }) => (
      <button
        key={key}
        type="button"
        role="radio"
        aria-checked={value === key}
        onClick={() => onChange(key)}
        data-testid={`${testIdPrefix}-${key}`}
        className={`inline-flex items-center gap-1.5 rounded-full px-3 font-medium transition-colors ${size === "sm" ? "py-1 text-xs" : "py-1.5 text-sm"} ${
          value === key ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"
        }`}
      >
        <Icon className="w-3.5 h-3.5" /> {label}
      </button>
    ))}
  </div>
);

export default AIModelSelector;
